export default "__VITE_ASSET__jhG48BLP__"